"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chips = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _atoms = require("../../atoms");

var _lodash = _interopRequireDefault(require("lodash"));

var _clickOutside = _interopRequireDefault(require("../../hooks/click-outside"));

var _modal = require("../modal");

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Chips = ({
  value,
  onChange,
  renderChip,
  dropdownWidth,
  dropdownOptions,
  renderDropdownOptions,
  chipsAlign,
  showRemoveIcon,
  width,
  label,
  showArrowIcon,
  labelMargin,
  dropdownPadding,
  showClearChipsButton,
  chipsClearHandler,
  minimumChips,
  enableCheckboxes,
  disabled
}) => {
  const [isEnabled, setEnabled] = (0, _react.useState)(false);
  const [selectedChips, setSelectedChips] = (0, _react.useState)([]);
  const [isModalVisible, setModalVisible] = (0, _react.useState)(false);
  const [mDropdownOptions, setmDropdownOptions] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setSelectedChips(() => {
      return value;
    });
  }, [value]);
  (0, _react.useEffect)(() => {
    setmDropdownOptions(() => {
      return dropdownOptions;
    });
  }, [dropdownOptions]);
  (0, _react.useEffect)(() => {
    mDropdownOptions.length === 0 && setEnabled(false);
  }, [mDropdownOptions]); // eslint-disable-next-line no-unused-vars

  const addChip = option => {
    if (!_lodash.default.isEmpty(_lodash.default.find(value, ['id', option.id]))) {
      return;
    }

    let chips = [...value, option];
    onChange(chips);
    setmDropdownOptions(() => {
      return mDropdownOptions.filter(op => op.id !== option.id);
    });
  };

  const removeChip = ({
    id,
    event
  }) => {
    event.stopPropagation();
    const val = value.filter(chip => chip.id === id);
    setmDropdownOptions(() => {
      return [...mDropdownOptions, val[0]];
    });
    const nextChips = value.filter(chip => chip.id !== id);
    onChange(nextChips);
    /*
    If remaining chips are less than minimum number of chips to show then
    hide modal as well because there is nothing to show in modal now
    */

    nextChips.length <= minimumChips && setModalVisible(false);
  };

  const onChangeOption = ({
    event,
    ...option
  }) => {
    event.stopPropagation();

    if (!option.optionChecked) {
      removeChip({ ...option,
        event
      });
      return;
    }

    addChip(option);
  };

  const renderChips = () => {
    return selectedChips.map((chip, idx) => {
      return idx + 1 <= minimumChips ? /*#__PURE__*/_react.default.cloneElement(renderChip(chip), { ...chip,
        onRemove: event => removeChip({ ...chip,
          idx,
          event
        }),
        index: idx,
        key: `chip${idx}`,
        ['data-testid']: `chip_${idx}`,
        tabIndex: idx,
        showRemoveIcon,
        disabled
      }) : idx + 1 === minimumChips + 1 && /*#__PURE__*/_react.default.createElement(_styles.StyledViewMoreButton, {
        onClick: viewMoreClickHandler,
        key: `chip${idx}`
      }, `+ View ${selectedChips.length - minimumChips} more`);
    });
  };

  const renderOptions = () => {
    /*
    1. For backward compatibility, users will get default implementation i.e
    		with checkboxes.
    2. If a user says he/she doesn't want checkboxes then a 'enableCheckboxes'
    		flag prop can be used which will then provide user a implementation
    		without checkboxes.
    3. If a user wants custom implementation, he/she can use
    		render props mechanism by passing a function using prop
    		'renderDropdownOptions' with his/her custom implementation
    */
    return mDropdownOptions.map((option, idx) => {
      return renderDropdownOptions ? // Provide custom user provided implementation
      renderDropdownOptions(option) : // Provide implementation without checkboxes
      !enableCheckboxes ? /*#__PURE__*/_react.default.createElement(_styles.StyledCustomDropdownRowDiv, {
        onClick: () => addChip(option)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-label"
      }, option.value)) :
      /*#__PURE__*/
      // Default implementation (with checkboxes) for backward compatibility
      _react.default.cloneElement( /*#__PURE__*/_react.default.createElement(_atoms.Checkbox, _extends({}, option, {
        className: "checkbox_background_hover"
      })), { ...option,
        checked: !_lodash.default.isEmpty(_lodash.default.find(value, ['id', option.id])),
        onChange: event => onChangeOption({ ...option,
          idx,
          optionChecked: event.target.checked,
          event
        }),
        index: idx,
        key: (0, _uuid.v4)(),
        ['data-testid']: `option_${idx}`,
        tabIndex: idx
      });
    });
  };

  const viewMoreClickHandler = event => {
    event.stopPropagation();
    setEnabled(false);
    setModalVisible(true);
  };

  const getExtraChips = () => {
    // This function will return all the remaining chips to show
    const extraChips = selectedChips.slice(minimumChips);
    const result = extraChips.map((chip, idx) => {
      return /*#__PURE__*/_react.default.cloneElement(renderChip(chip), { ...chip,
        onRemove: event => removeChip({ ...chip,
          idx: idx + minimumChips,
          event
        }),
        index: idx + minimumChips,
        key: `chip${idx + minimumChips}`,
        ['data-testid']: `chip_${idx + minimumChips}`,
        tabIndex: idx + minimumChips,
        showRemoveIcon
      });
    });
    return /*#__PURE__*/_react.default.createElement(_styles.StyledViewModalBody, null, result);
  };

  const clickRef = (0, _react.useRef)();
  (0, _clickOutside.default)(clickRef, () => {
    setEnabled(false);
  }, isEnabled);

  const handleClearChips = event => {
    event.stopPropagation();
    setmDropdownOptions(dropdownOptions);
    chipsClearHandler && chipsClearHandler(event);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isModalVisible && /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    headerButtons: [],
    footerButtons: [{
      text: 'Close',
      isPrimary: false,
      onClick: () => setModalVisible(false)
    }],
    onClose: () => setModalVisible(false),
    onBackdropClick: () => setModalVisible(false),
    render: () => getExtraChips()
  }), /*#__PURE__*/_react.default.createElement(_styles.StyledMultiSelectDropdownContainer, {
    ref: clickRef,
    chipsIn: value.length > 0,
    width: width,
    labelMargin: labelMargin,
    onClick: () => setEnabled(true),
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledChipsLabelWrapper, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "floating-dropdown-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chips-label"
  }, label)), showClearChipsButton && value.length > 0 && /*#__PURE__*/_react.default.createElement(_styles.StyledClearChipsIconWrapper, {
    className: "chips-clear-button"
  }, /*#__PURE__*/_react.default.createElement(_atoms.IconButton, {
    icon: "Close",
    isRounded: true,
    buttonSize: "24px",
    iconSize: 14,
    onClick: handleClearChips
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: "dropDown-trigger_icon"
  }, !showArrowIcon ? null : !isEnabled ? /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "DownArrow",
    size: 16,
    onClick: () => setEnabled(!isEnabled)
  }) : /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "UpArrow",
    size: 16,
    onClick: () => setEnabled(!isEnabled)
  })), value.length > 0 && /*#__PURE__*/_react.default.createElement(_styles.StyledChipsRenderContainer, {
    chipsAlign: chipsAlign,
    onClick: () => setEnabled(!isEnabled)
  }, renderChips()), isEnabled && mDropdownOptions.length > 0 && /*#__PURE__*/_react.default.createElement(_styles.StyledDropdownContainer, {
    dropdownWidth: dropdownWidth,
    dropdownPadding: dropdownPadding
  }, renderOptions())));
};

exports.Chips = Chips;
Chips.propTypes = {
  /** chips contain width */
  width: _propTypes.default.string,

  /** A Dropdown options width */
  dropdownWidth: _propTypes.default.string,

  /** An array of options that represents the value for Options */
  dropdownOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })).isRequired,

  /** An array of data that represents the value of the chips */
  value: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })).isRequired,

  /** A function called when the value of chips changes, passes the chips value as an argument. */
  onChange: _propTypes.default.func.isRequired,

  /** For custom chip usage. A function that passes the value of the chip as an argument, must return an element that will be rendered as each chip. */
  renderChip: _propTypes.default.func,

  /** For custom Options usage. A function that passes the option of the dropdown as an argument, must return an element that will be rendered as each option. */
  renderDropdownOptions: _propTypes.default.func,

  /** For custom field for dropdown container padding. */
  dropdownPadding: _propTypes.default.string,

  /** A value for changing the direction chip's alignment */
  chipsAlign: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /** to enable Remove Icon*/
  showRemoveIcon: _propTypes.default.bool,

  /** A Field for Multi Select Label*/
  label: _propTypes.default.string,

  /** A Field to enable dropdown Icons*/
  showArrowIcon: _propTypes.default.bool,

  /** A Field for custom margin for label, default is 16px */
  labelMargin: _propTypes.default.string,

  /** Minimum number of chips to render before grouping them to 'view more' button */
  minimumChips: _propTypes.default.number,

  /** Show/Hide clear button to deselect all selected chips */
  showClearChipsButton: _propTypes.default.bool,

  /** Function to clear all the selected chips */
  chipsClearHandler: _propTypes.default.func,

  /** Enable/disable checkboxes in dropdown */
  enableCheckboxes: _propTypes.default.bool,

  /** Enable/Disable chips component */
  disabled: _propTypes.default.bool
};
Chips.defaultProps = {
  width: '100%',
  dropdownWidth: '100%',
  dropdownOptions: [],
  value: [],
  labelMargin: '16px',
  onChange: () => {},
  // eslint-disable-next-line react/prop-types
  renderChip: ({
    label,
    ...restProps
  }) => /*#__PURE__*/_react.default.createElement(_atoms.Chip, _extends({}, restProps, {
    className: "chips-margin-bottom"
  }), label),
  chipsAlign: 'vertical',
  showRemoveIcon: true,
  label: 'Label',
  showArrowIcon: false,
  dropdownPadding: '14px 24px',
  minimumChips: 5,
  enableCheckboxes: true,
  disabled: false
};